const routes = [
  {
    path: 'manpower-log',
    name: 'manpowerLog',
    component: () => import(/* webpackChunkName: "manpower-log" */ './views/ManpowerLog.vue'),
    meta: {
      permissionRequired: true,
    },
  },
];

export default routes;
